import { render, staticRenderFns } from "./EditProductMods.vue?vue&type=template&id=16d2b3f1"
import script from "./EditProductMods.vue?vue&type=script&lang=js"
export * from "./EditProductMods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports